export type { Locale } from "@i18n/react";
export {
  DEFAULT_LOCALE,
  locales,
  useFormatter,
  useLocale,
  useDateFormatter,
} from "@i18n/react";
/**
 * Scoped to the messages the app declares through `AppMessagesConfig` — see
 * `@i18n/react/src/types/appMessages.types.ts`.
 */
export type {
  AppMessages,
  AppMessagesConfig,
  AppTranslator,
  I18nMessageProps,
  LooseMessageKey,
  MessageKey,
  MessageNamespace,
  UseAppTranslations,
} from "@i18n/react/app";
export { I18nMessage, useTranslations } from "@i18n/react/app";

export { usePathname } from "./hooks/usePathname";
export { useSetLocale } from "./hooks/useSetLocale";
export type { LinkProps } from "./lib/navigation";
export {
  getPathname,
  Link,
  permanentRedirect,
  redirect,
  useRouter,
} from "./lib/navigation";
export { routing } from "./lib/routing";
export { I18nProvider } from "./providers/I18nProvider";
export { basei18n } from "./utils/basei18n";
export { getLocalesAsParams } from "./utils/getLocalesAsParams";
